export default "__VITE_ASSET__B18t3n0V__"